import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
import ldRouter from './modules/ld'
import homeRouter from './modules/home'
import projectRouter from './modules/project'
import statisticsRouter from './modules/statistics'
import messageRouter from './modules/message'
import materialRouter from './modules/material'

const router = new VueRouter({
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      redirect: '/home',
    },
    // 首页
    // {
    //   path: '/home',
    //   name: 'Home',
    //   component: () => import('@/views/weihai/index.vue')
    // },
    {
      path: '/empty',
      name: 'Empty',
      component: () => import('@/views/weihai/empty.vue')
    },
    {
      path: '/custom',
      name: 'Custom',
      component: () => import('@/views/weihai/custom.vue')
    },
    {
      path: '/select',
      name: 'Select',
      component: () => import('@/views/weihai/select.vue')
    },
    {
      path: '/result',
      name: 'Result',
      component: () => import('@/views/weihai/result.vue')
    },
    {
      path: '/license',
      name: 'license',
      component: () => import('@/views/license/index.vue')
    },
    ...ldRouter,
    ...homeRouter,
    ...projectRouter,
    ...statisticsRouter,
    ...messageRouter,
    ...materialRouter,
  ]
})

export default router
